import Vue from 'vue'
//加载文件
import App from './App'
//加载文件夹
import router from './router'
//引入公共配置文件
import config from '../config/index.js'
Vue.prototype.config = config;
// 引入iview
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
// 引入对css less的支持
import '!style-loader!css-loader!less-loader!./theme/index.less'
//引入交互
import axios from 'axios'
//为axios起一个别名
Vue.prototype.$http = axios;
//引入vuex
import store from './store';

//全局提示插件
import MessageUtils from '@/utils/MessageUtils.js'
Vue.use(MessageUtils)
import NoticeUtils from '@/utils/NoticeUtils.js'
Vue.use(NoticeUtils)
//导出IMAGE
import ExportImage from '@/utils/ExportImage.js'
Vue.use(ExportImage)
//导出PDF
import ExportPDF from '@/utils/ExportPDF.js'
Vue.use(ExportPDF)
//引入vue-bus
import vueBus from './utils/vue-bus.js'
Vue.use(vueBus)
import JsonViewer from 'vue-json-viewer'

// Import JsonViewer as a Vue.js plugin
Vue.use(JsonViewer)
//解决在ie11中打开空页面的问题
import 'babel-polyfill'

//公共js处理方法
import ChartsUtils from '@/utils/ChartsUtils.js'
Vue.prototype.ChartsUtils = ChartsUtils;


/*
 template:一个字符串模板作为 Vue 实例的标识使用。
模板将会 替换 挂载的元素。挂载元素的内容都将被忽略，除非模板的内容有分发插槽。
components:包含 Vue 实例可用组件的哈希表
 */


var vm  = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});

const AUTH_WHITE_LIST = ['/', '/waiting', '/login', '/loginFromYN', '/errorPage','/forgetPassword','/messagePage','/pcTip','/!*']

// 拦截通过地址栏直接访问的路由
router.beforeResolve((to, from, next) => {
  if (AUTH_WHITE_LIST.indexOf(to.path) > -1) {
    next()
  } else {
    validatorUserInfo(to, from, next)
  }
})

//全局守卫
router.beforeEach((to,from,next) =>{
  if (AUTH_WHITE_LIST.indexOf(to.path) > -1) {
    next()
  } else {
    validatorUserInfo(to, from, next)
  }
})

function validatorUserInfo(to, from, next){
  var self = this;
  vm.$http({
    method:'post',
    url:vm.config.serverUrl+'/mobile/userInfo.json',
    data:{}
  }).then(function (response) {
    if(response.data.code==="1" && response.data.userInfo){
      sessionStorage.userInfo = JSON.stringify(response.data.userInfo);
      sessionStorage.showSystem = response.data.showSystem;
      sessionStorage.schoolName = response.data.schoolName;
      next();
    }else{
      vm.$Message.info('获取用户信息超时，请重新登录！');
      next("/");
    }
  }).catch(function (response) {
    console.log(response);
  });
}



// WEBPACK FOOTER //
// ./src/main.js